import * as React from "react";
import * as questionIds from "@teamprevent/common/questionnaires/questionnaireConfig/genericCase/questionIds";
import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";
import { QuestionConfig, getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { QuestionAnswer } from "@teamprevent/common/questionnaires/model";

import { Label } from "semantic-ui-react";
import { CheckboxQuestion } from "@teamprevent/common/questionnaires/components/questions/CheckboxQuestion";

import { confidentialitySectionId, totallyConfidentialAnswer } from "../GenericCaseForm";

interface Props {
    questionConfigs: QuestionConfig[];
    getAnswerToQuestionWithId(id: string): QuestionAnswer;
    readonly: boolean;
}

export const ConfidentialitySection: React.FunctionComponent<Props> = (
    {
        questionConfigs,
        getAnswerToQuestionWithId,
        readonly
    }) => {

    return (
        <ContextAwareProgressBarQuestionnaireSection id={confidentialitySectionId} title="Confidentiality">
            {getAnswerToQuestionWithId(questionIds.TotallyConfidential) === totallyConfidentialAnswer &&
            <p className="additional-spacing-paragraph">
                <Label basic color="red">
                    By ticking this box, you have hidden this case from everyone in your organisation
                    including the HR Team apart from yourself and the employee you are referring.
                    If you do not wish to hide this case, please DO NOT TICK this box and
                    ensure that it remains unticked when you submit your referral.
                </Label>
            </p>
            }
            <CheckboxQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.TotallyConfidential)}
                readonly={readonly}
                value={totallyConfidentialAnswer}
                hideDivider={true}
            />
        </ContextAwareProgressBarQuestionnaireSection>
    );
};
